import { useTranslation } from "react-i18next";
import { useGlobalContext } from "../../stores/Global";
import useBreakpoint from "../../hooks/useBreakpoint";
import { Box, Stack, Tab, Tabs } from "@mui/material";
import { Route, Routes, useMatch, useNavigate } from "react-router";
import ProductsPage from "./Products";
import ContactsPage from "./Contacts";
import CompaniesPage from "./Companies";
import { useEffect, useState } from "react";
import ArchiveIcon from "@mui/icons-material/Archive";
import StoreIcon from "@mui/icons-material/Store";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";

function DefaultRoute() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/m/business/companies", { replace: true });
  }, []);
  return null;
}
export default function BusinessPage() {
  const { t } = useTranslation("Business");
  const { context, setContext } = useGlobalContext();
  const navigate = useNavigate();
  const match = useMatch("/m/business/:section/*");
  const section = match?.params.section;
  const [value, setValue] = useState(() => {
    if (section === "companies") return 0;
    else if (section === "contacts") return 1;
    else if (section === "products") return 2;
    else return 0;
  });
  const breakpoint = useBreakpoint();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (newValue === 0) navigate("/m/business/companies");
    else if (newValue === 1) navigate("/m/business/contacts");
    else if (newValue === 2) navigate("/m/business/products");
  };

  return (
    <Stack sx={{ height: 1 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        allowScrollButtonsMobile
        indicatorColor="primary"
        textColor="inherit"
        sx={{
          "& .MuiTab-root": {
            p: 1,
          },
          "& .MuiTouchRipple-root": {
            p: 0,
          },
        }}
      >
        <Tab iconPosition="start" label="Companies" icon={<StoreIcon />} />
        <Tab
          iconPosition="start"
          label="Contacts"
          icon={<ContactPhoneIcon />}
        />
        <Tab iconPosition="start" label="Products" icon={<ArchiveIcon />} />
      </Tabs>
      <Box flexGrow={1} height={1} overflow="hidden" mt={1}>
        <Routes>
          <Route index element={<DefaultRoute />} />
          <Route path="companies">
            <Route index element={<CompaniesPage />} />
            <Route path=":_id" element={<CompaniesPage />} />
          </Route>
          <Route path="contacts">
            <Route index element={<ContactsPage />} />
            <Route path=":_id" element={<ContactsPage />} />
          </Route>
          <Route path="products">
            <Route index element={<ProductsPage />} />
            <Route path=":_id" element={<ProductsPage />} />
          </Route>
        </Routes>
      </Box>
    </Stack>
  );
}
